import { boolean, nullable, number, object, string } from "superstruct";

export const ReviewTranslationSuportLangRequestSchema = object({
    locale: string(),
});

export const ReviewTranslationSuportLangResponseSchema = object({
    locale: string(),
    supported: boolean(),
});

export const ReviewTranslationRequestSchema = object({
    reviewId: number(),
    targetLanguage: string(),
});

export const ReviewTranslationResponseSchema = object({
    reviewId: number(),
    targetLanguage: string(),
    body: string(),
    title: nullable(string()),
    reply: nullable(string()),
});
